import { Flows } from '../../../../util/Types/Folder';
import type { SearchItemType, SpaceOption } from '../types';
import { getSpaceName, isFluxbotFlow, isFormFlow } from '../utils';

export const getItemType = (item: Flows): SearchItemType => {
  if (isFormFlow(item)) return 'interface';
  if (isFluxbotFlow(item)) return 'fluxbot';
  return 'agent';
};

export { getSpaceName };
export type { Flows as SearchableItem, SpaceOption };
